<template>
  <div>
    <Dialog
      :title="$t('submitInvoiceForm.headers.submitInvoice')"
      :visible.sync="dialogOpened"
      data-test="submit_invoice_dialog"
      width=""
      top=""
      left
      :append-to-body="true"
      :before-close="close"
    >
      <Alert
        type="error"
        :title="$t(`flashMessages.${errorMessage}`)"
        v-if="errorMessage"
        class="mb-20"
      />
      <Form
        ref="emailForm"
        :model="emailForm"
        :rules="validationRules"
      >
        <FormGroup
          prop="senderEmail"
          spacing="xs"
          :label="$t('submitInvoiceForm.fields.senderEmail.label')"
        >
          <TextInput
            name="senderEmail"
            data-test="sender_email"
            type="text"
            v-model="senderEmail"
            id="invoice_email_sender"
          />
        </FormGroup>
        <FormGroup
          prop="recipientEmail"
          spacing="xs"
          :label="$t('submitInvoiceForm.fields.recipientEmail.label')"
        >
          <EmailSelect
            v-model="recipientEmail"
            :placeholder="$t('submitInvoiceForm.fields.recipientEmail.placeholder')"
            data-test="recipient_email"
            id="invoice_email_recipients_str"
            name="recipientEmail"
            multiple
            allow-create
            filterable
            remote
            :loading="buttonLoading.send"
            :remote-method="handleSearch"
            default-first-option
            ref="suggestion"
            autocomplete="new-password"
          >
            <Option
              v-for="option in recipientSuggestions"
              :key="option.value"
              :label="option.value"
              :value="option.value"
            />
          </EmailSelect>
        </FormGroup>
        <FormGroup
          prop="copyToSender"
          spacing="xs"
          offset="small"
        >
          <Checkbox
            v-model="copyToSender"
            data-test="send_copy_to_sender"
          >
            {{ $t('submitInvoiceForm.fields.copyToSender.inputHelp') }}
          </Checkbox>
        </FormGroup>

        <FormGroup
          prop="subject"
          spacing="xs"
          :label="$t('submitInvoiceForm.fields.subject.label')"
        >
          <TextInput
            name="subject"
            data-test="email_subject"
            type="text"
            v-model="subject"
            id="invoice_email_subject"
          />
        </FormGroup>
        <FormGroup
          prop="message"
          spacing="xs"
        >
          <TextInput
            name="message"
            data-test="email_message"
            type="textarea"
            rows="11"
            v-model="message"
            id="invoice_email_body"
          />
        </FormGroup>
        <FormGroup
          prop="attachment"
          spacing="xs"
        >
          <UploadAttachment
            class="form-file"
            name="attachment"
            ref="attachments"
            :auto-upload="true"
            :label="$t('submitInvoiceForm.fields.attachments.label')"
            :multiple="true"
            :kind="kind"
          />
        </FormGroup>
        <span
          class="dialog-footer"
        >
          <Button
            @click="close"
            icon="icon icon-cross"
            data-test="close_dialog"
            new-design
            plain
            size="large"
            type="primary"
          >
            {{ $t('submitInvoiceForm.buttons.close') }}
          </Button>
          <Button
            :loading="buttonLoading.send"
            @click="submit('emailForm')"
            icon="icon icon-send-line"
            data-test="submit_form"
            new-design
            size="large"
            type="primary"
          >
            {{ $t('submitInvoiceForm.buttons.confirm') }}
          </Button>
        </span>
      </Form>
    </Dialog>
  </div>
</template>
<script>

import { mapFields } from 'vuex-map-fields';
import { mapGetters } from 'vuex';
import debounce from 'throttle-debounce/debounce';
import { PATH_INVOICES_OVERVIEW } from '~/router';

export default {
  components: {
    UploadAttachment: () => import('~/components/Common/UploadAttachment.vue'),
    EmailSelect: () => import('../InvoiceForm/inputs/EmailSelect.vue'),
  },
  data() {
    return {
      buttonLoading: {
        send: false,
      },
      recipientSuggestions: [],
    };
  },
  computed: {
    ...mapFields('submitInvoiceForm', [
      'dialogOpened',
      'senderEmail',
      'recipientEmail',
      'copyToSender',
      'subject',
      'isdoc',
      'message',
      'errorMessage',
    ]),
    ...mapGetters('submitInvoiceForm', [
      'emailForm',
      'validationRules',
    ]),
    kind() {
      return { type: 'email' };
    },
  },
  methods: {
    close() {
      this.$store.dispatch('submitInvoiceForm/closeDialog');
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.buttonLoading.send = true;
          this.$store.dispatch('submitInvoiceForm/submitForm', { attachmentIds: this.$refs.attachments.attachmentIds })
            .then(() => {
              this.$router.push({ name: PATH_INVOICES_OVERVIEW });
            })
            .finally(() => {
              this.buttonLoading.send = false;
            });
          return true;
        }
        return false;
      });
    },
    handleSearch: debounce(1000, function (query) { this.fetchSuggestions(query); }),
    fetchSuggestions(query) {
      if (query !== '') {
        this.$store.dispatch('submitInvoiceForm/getRecipientSuggestions', query)
          .then((items) => {
            this.recipientSuggestions = items;
          })
          .catch(() => {
            this.recipientSuggestions = [];
          });
      }
    },
  },
  watch: {
    dialogOpened(newVal) {
      this.$nextTick(() => {
        if (newVal === false) {
          this.$refs.emailForm.resetFields();
        } else {
          this.fetchSuggestions();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.uploader--attachment {
  border-radius: 8px;
  border: 1px solid $blue-light;
}
</style>
